import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DeviceSmartphoneIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.8065 3.21973H8.19355C7.30988 3.21973 6.59357 3.9361 6.59357 4.81977V19.1798C6.59357 20.0634 7.30988 20.7797 8.19355 20.7797H15.8065C16.6901 20.7797 17.4065 20.0634 17.4065 19.1798V4.81977C17.4065 3.9361 16.6901 3.21973 15.8065 3.21973ZM15.7465 19.1197H8.25355V4.87976H15.7465V19.1197ZM11.9829 16.5557C11.5266 16.5557 11.1533 16.9498 11.1533 17.3854C11.1533 17.8624 11.5266 18.2356 11.9829 18.2356C12.46 18.2356 12.8333 17.8624 12.8333 17.3854C12.8333 16.9498 12.46 16.5557 11.9829 16.5557ZM14.2653 5.98144H9.73475V7.66143H14.2653V5.98144Z"
      />
    </SvgIcon>
  );
});
